import { getWelcomeMessage } from "asos-site-chrome-store-presentation";

const getWelcomeMessageClosedState = () => getWelcomeMessage();

export default getWelcomeMessageClosedState;
